module.exports = __webpack_public_path__ + "img/stick_activites_geocaching.66831e80.svg";